
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M12 11.182a.742.742 0 01-.188.469A.936.936 0 0012 11.1l-.932.9c.254 0 .485-.09.653-.237a.779.779 0 01-.545.237H5.824C5.368 12 5 11.597 5 11.1s.368-.899.824-.899h4.308l.003-6.383c0-.452.418-.818.933-.818.514 0 .932.366.932.818v7.364zM10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0z","id":"a"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill-opacity":".3","fill":"#000","xlink:href":"#a"}}),_c('use',{attrs:{"fill":"#8E8E92","xlink:href":"#a"}})])])
          )
        }
      }
    